import React from 'react';

import { Button, Grid } from '@mui/material';

import { DateFormatPatterns } from '@clearverify/constants';
import { formatDate, formatPhoneNumber } from '@clearverify/utils';

import { PlatformStaffItemFragment } from 'src/api';
import { DetailGridItem } from 'src/components/common';
import { useCurrentPlatformStaff } from 'src/hooks/platformStaff';

import { PlatformStaffDetailModalContentForm } from './components';

interface PlatformStaffDetailModalContentProps {
  platformStaff: PlatformStaffItemFragment;
  closeModal: () => void;
  switchClosability: (isClosureAllowed: boolean) => void;
}

export const PlatformStaffDetailModalContent: React.FC<PlatformStaffDetailModalContentProps> = ({
  platformStaff,
  closeModal,
  switchClosability,
}) => {
  const { platformStaffId, isAbleToManagePlatformStaff } = useCurrentPlatformStaff();

  const handleClose = React.useCallback(() => closeModal(), [closeModal]);

  // Super Admins edit every other staff member, pending invites included, but not themselves.
  const shouldRenderForm = isAbleToManagePlatformStaff && platformStaff.id !== platformStaffId;

  return (
    <Grid container spacing={2}>
      <Grid size={6}>
        <DetailGridItem
          topText="First Name"
          bottomText={platformStaff.user.firstName}
          withContainer={false}
        />
      </Grid>
      <Grid size={6}>
        <DetailGridItem
          topText="Date of Birth"
          bottomText={formatDate(
            platformStaff.user.birthDate,
            DateFormatPatterns.shortDateWithSlash,
          )}
          withContainer={false}
        />
      </Grid>
      <Grid size={6}>
        <DetailGridItem
          topText="Last Name"
          bottomText={platformStaff.user.lastName}
          withContainer={false}
        />
      </Grid>
      <Grid size={6}>
        <DetailGridItem
          topText="Phone Number"
          bottomText={formatPhoneNumber(platformStaff.user.phoneNumber)}
          withContainer={false}
        />
      </Grid>
      <Grid size={12}>
        <DetailGridItem
          topText="Email Address"
          bottomText={platformStaff.user.email}
          withContainer={false}
        />
      </Grid>

      {shouldRenderForm ? (
        <Grid size={12}>
          <PlatformStaffDetailModalContentForm
            platformStaff={platformStaff}
            closeModal={closeModal}
            switchClosability={switchClosability}
          />
        </Grid>
      ) : (
        <Grid size={12} display="flex" alignItems="center" justifyContent="center" mt={2}>
          <Button variant="outlined" color="error" onClick={handleClose}>
            Close
          </Button>
        </Grid>
      )}
    </Grid>
  );
};
